import React, { FC, useEffect, useState } from 'react';
import "./projects.css";


const Projects_Header: FC = () => {

    return (
        <div>
            <div className="projects">
                <div className={"my_projects_headline_container"}>
                    <h1>Projekte</h1>
                </div>
            </div>
        </div>
    );
}

export default Projects_Header;
